import React from "react";

import "./ListItem.scss";

const ListItem = ({ data, curr, func }) => {
  function setIdx(idx) {
    func(idx);
  }
  function getNumberFormat(price) {
    return new Intl.NumberFormat("en-US").format(price);
  }

  function getEtc(item) {
    if (item.discountTotal !== 0) return "할인 적용";
    if (item.offerCd?.length > 0) return "할인 대상";
    return "";
  }

  return (
    <>
      {data.itemSeq ? (
        <div className={curr ? "list-item-focus" : "list-item"} onClick={setIdx}>
          <div className="item-name">
            <p>{data.pluNm}</p>
            <p className="item-price">{getNumberFormat(data.salePrice)}</p>
          </div>
          <div className="item-qty">{getNumberFormat(data.saleQty)}</div>
          <div className="item-total">{getNumberFormat(data.totAmt)}</div>
          <div className="item-etc">{getEtc(data)}</div>
        </div>
      ) : (
        <div className="list-item"></div>
      )}
    </>
  );
};

export default ListItem;
